import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService, SearchConfig, TranslationService } from '@spartacus/core';
import { catchError, map, Observable } from 'rxjs';
import { failStatus } from '../../../../../../core/models/request-status.model';

@Injectable({
  providedIn: 'root',
})
export class QuotesSearchProductAdapter {
  constructor(
    private http: HttpClient,
    private translationService: TranslationService,
    private occEndPointService: OccEndpointsService,
  ) {}

  get(query: string, searchConfig?: SearchConfig): Observable<any> {
    const params: { [key: string]: string } = {};
    params['query'] = query;
    params['pageSize'] = '5';

    if (searchConfig?.searchQueryContext) {
      params['searchQueryContext'] = searchConfig?.searchQueryContext;
    }

    if (searchConfig?.currentPage) {
      params['currentPage'] = searchConfig?.currentPage.toString();
    }

    const url = this.occEndPointService.buildUrl('productSearch', { queryParams: params });

    return this.http.get(url, {}).pipe(
      map((data: any) => {
        return data;
      }),
      catchError(() => {
        return this.translationService.translate('generic.error').pipe(
          map(textError => ({
            ...failStatus,
            message: textError,
          })),
        );
      }),
    );
  }
}
